/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaStepAlt from 'DesignSystem/TysiaStepAlt/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/Step/Display/Content"
  
}) {
let stepsCurrentIndexValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'current_index',
})
let stepItemIndexValueData = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'index',
})
let aggregateData = fromAggregate.equals(stepsCurrentIndexValueData, stepItemIndexValueData)
let stepItemIndexValueData1 = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'index',
})
let constantData = 1
let aggregateData1 = fromAggregate.add(stepItemIndexValueData1, constantData)
let stepNameValueData = fromData.useDataFormat({ viewPath,
context: 'step',
path: 'name',
format: fromHelpers.getTitle,
})
let stepStatusValueData = fromData.useDataValue({ viewPath,
context: 'step',
path: 'status',
})
let constantData1 = 'completed'
let aggregateData2 = fromAggregate.equals(stepStatusValueData, constantData1)
  return (<React.Fragment
>
<TysiaStepAlt
  viewPath={`${viewPath}/TysiaStepAlt`}
 data="steps.current_index"
 data="step_item.index"
 aggregate="/Data/aggregate.js equals"
 selected={aggregateData}
 data="step_item.index"
 data={1}
 aggregate="/Data/aggregate.js add"
 step={aggregateData1}
 data="step.name"
 format="helpers.js getTitle"
 text={stepNameValueData}
 size="normal"
 data="step.status"
 data="'completed'"
 aggregate="/Data/aggregate.js equals"
 complete={aggregateData2}
/>
{children}
</React.Fragment>)
}